import { render, staticRenderFns } from "./ClientDialogShowBill.vue?vue&type=template&id=4e77ce24&scoped=true"
import script from "./ClientDialogShowBill.vue?vue&type=script&lang=js"
export * from "./ClientDialogShowBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e77ce24",
  null
  
)

export default component.exports